import { useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import CloseIcon from '@mui/icons-material/Close';
// third party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { FormattedMessage, useIntl} from 'react-intl';

// project imports
import FontFamily from '../../../Customization/FontFamily';
import BoxContainer from '../../../Customization/BoxContainer';
import PresetColor from '../../../Customization/PresetColor';
import FontSize from '../../../Customization/FontSize';
import ThemeModeLayout from '../../../Customization/ThemeMode';
import SidebarDrawer from '../../../Customization/SidebarDrawer';

import { ThemeMode } from 'config';
import MainCard from 'ui-component/cards/MainCard';
import useConfig from 'hooks/useConfig';

// assets
import { IconSettings, IconPlus, IconTextSize, IconColorSwatch } from '@tabler/icons-react';
import darkModeIcon from 'assets/images/icons/dark_mode.svg';
import { IconMoon, IconSun } from '@tabler/icons-react';
function CustomTabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

export default function LiveCustomizeSection() {
  const theme = useTheme();
  const { mode, onReset } = useConfig();

  // drawer on/off
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen(!open);
  };

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {/* Live Customize button in header */}
      <Box sx={{ ml: 1 }}>
          <IconButton
            onClick={handleToggle}
            sx={{
              color: 'white.paper',
              padding: 0.6,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            <Box component='img' src={darkModeIcon} alt="Dark Mode Icon" width={26} height={26} />
          </IconButton>
      </Box>

      {/* Customization Drawer */}
      <Drawer anchor="right" onClose={handleToggle} open={open} PaperProps={{ sx: { width: {xs: '100%', sm: 520},marginTop: { xs: '48px', md: '70px' }, } }}>
        {open && (
          <PerfectScrollbar>
            <MainCard content={false} border={false}>
              <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center', justifyContent: 'space-between', p: '16px 16px 16px 30px' }}>
                <Typography sx={{fontSize:'20px', fontWeight: '500'}} color='grey.900'>
                  <FormattedMessage id="themeCustomization" defaultMessage="Theme Customization" />
                </Typography>
                <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
                  <Button variant="outlined" sx={{fontSize:'14px'}} id="reset" onClick={() => onReset()}>
                    <FormattedMessage id="reset" defaultMessage="Reset" />
                  </Button>
                  <IconButton onClick={handleToggle} size="small">
                    <CloseIcon size="small" id="addDrawer-closeIcon" />
                  </IconButton>
                </Stack>
              </Stack>
              <Divider />
                <Grid container sx={{mb:5, pb:2}}>
                  <Grid size={12} sx={{ p: '20px 30px', display: 'flex', flexDirection: 'column', gap: 3}}>
                    {/* layout type */}
                    <ThemeModeLayout />
                    <Divider />
                    {/* font size */}
                    <FontSize />
                  </Grid>
                </Grid>
            </MainCard>
          </PerfectScrollbar>
        )}
      </Drawer>
    </>
  );
} 